import { render, staticRenderFns } from "./insuranceCompanyList.vue?vue&type=template&id=47c2a728&scoped=true"
import script from "./insuranceCompanyList.vue?vue&type=script&setup=true&lang=js"
export * from "./insuranceCompanyList.vue?vue&type=script&setup=true&lang=js"
import style0 from "./insuranceCompanyList.vue?vue&type=style&index=0&id=47c2a728&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c2a728",
  null
  
)

export default component.exports